module.exports = __webpack_public_path__ + "img/image3.4cccd9fd.jpg";